import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';

import Auth from '../Query/Auth';

type PrivateRouteProps<T> = T & { component: any };

export default ({ component: Component, ...rest }: PrivateRouteProps<any>) => {
  return (
    <Auth>
      {(data: any) => (
        <Route
          {...rest}
          render={props =>
            data.isUserAuthenticated() ? (
              <div>
                <Component {...props} {...rest} />
              </div>
            ) : (
                <Redirect to="/" />
              )
          }
        />
      )}
    </Auth>
  );
};



// WEBPACK FOOTER //
// ./src/components/Layout/ProtectedRoute.tsx